export default {
  meta: {
    title: '加盟首页'
  }
};

